import styled from "styled-components";

const StyledContainer = styled.div`
  border-radius: 8px;
  background-color: #f7f7f8;
  padding: 24px;
  color: #706f7b;
  font-size: 14px;
  i {
    color: #858490;
  }
`;

function InfoRow() {
  return (
    <StyledContainer className="flex gap-2 mt-3 mb-4">
      <i className="pi pi-info-circle mt-1" />
      <p>
        {`We'll reallocate your payments if, after insurance adjustments, your responsibility shifts from one provider to another. This can happen when one provider bills earlier than expected.`}
      </p>
    </StyledContainer>
  );
}

export default InfoRow;
